import { CALL_API } from '../../../middleware/api';
import { apiEndpoints } from '../../../services/ApiEndpointsConstants';

import * as API from '../../../services/ApiEndpointsConstants';
import * as AdminConstants from './AdminConstants';

export function getAllUsersData() {
  return {
    [CALL_API]: {
      endpoint: apiEndpoints().entity(API.GET_ALL_USERS),
      types: [
        AdminConstants.GET_ALL_USERS_DATA_REQUEST,
        AdminConstants.GET_ALL_USERS_DATA_SUCCESS,
        AdminConstants.GET_ALL_USERS_DATA_CLEAR
      ]
    }
  };
}

export function getUserDataById(userId) {
  return {
    [CALL_API]: {
      endpoint: apiEndpoints()
        .entity(API.GET_USER_BY_ID)
        .replace('{id}', userId),
      types: [
        AdminConstants.GET_USER_DATA_BY_ID_REQUEST,
        AdminConstants.GET_USER_DATA_BY_ID_SUCCESS,
        AdminConstants.GET_USER_DATA_BY_ID_FAILED
      ]
    }
  };
}

export function createNewUser(requestData) {
  return {
    [CALL_API]: {
      config: {
        data: requestData,
        method: 'post'
      },
      endpoint: apiEndpoints().entity(API.CREATE_USER),
      types: [
        AdminConstants.SAVE_USER_DATA_REQUEST,
        AdminConstants.SAVE_USER_DATA_SUCCESS,
        AdminConstants.SAVE_USER_DATA_FAILED
      ]
    }
  };
}

export function updateUserData(requestData) {
  return {
    [CALL_API]: {
      config: {
        data: requestData,
        method: 'put'
      },
      endpoint: apiEndpoints().entity(API.UPDATE_USER),
      types: [
        AdminConstants.UPDATE_USER_DATA_REQUEST,
        AdminConstants.UPDATE_USER_DATA_SUCCESS,
        AdminConstants.UPDATE_USER_DATA_FAILED
      ]
    }
  };
}

export function updateUserPassword(requestData) {
  return {
    [CALL_API]: {
      config: {
        data: requestData,
        method: 'put'
      },
      endpoint: apiEndpoints().entity(API.RESET_USER_PASSWORD),
      types: [
        AdminConstants.RESET_USER_PASSWORD_REQUEST,
        AdminConstants.RESET_USER_PASSWORD_SUCCESS,
        AdminConstants.RESET_USER_PASSWORD_FAILED
      ]
    }
  };
}

export function getUserQueuesData(userId) {
  return {
    [CALL_API]: {
      endpoint: `${apiEndpoints().entity(
        API.GET_USER_QUEUE_BY_ID
      )}?userId=${userId}`,
      types: [
        AdminConstants.GET_USER_QUEUES_DATA_REQUEST,
        AdminConstants.GET_USER_QUEUES_DATA_SUCCESS,
        AdminConstants.GET_USER_QUEUES_DATA_FAILED
      ]
    }
  };
}

export function updateUserQueues(userId, requestData) {
  return {
    [CALL_API]: {
      config: {
        data: requestData,
        method: 'put'
      },
      // endpoint: apiEndpoints().entity(API.REPLACE_ALL_USER_QUEUE),
      endpoint: `${apiEndpoints().entity(
        API.REPLACE_ALL_USER_QUEUE
      )}?userId=${userId}`,
      types: [
        AdminConstants.REPLACE_USER_QUEUES_DATA_REQUEST,
        AdminConstants.REPLACE_USER_QUEUES_DATA_SUCCESS,
        AdminConstants.REPLACE_USER_QUEUES_DATA_FAILED
      ]
    }
  };
}

export function getQueueCount(requestData) {
  return {
    [CALL_API]: {
      config: {
        data: requestData,
        method: 'post'
      },
      endpoint: apiEndpoints().entity(API.USER_QUEUE_COUNT),
      types: [
        AdminConstants.GET_USER_QUEUES_COUNT_DATA_REQUEST,
        AdminConstants.GET_USER_QUEUES_COUNT_DATA_SUCCESS,
        AdminConstants.GET_USER_QUEUES_COUNT_DATA_FAILED
      ]
    }
  };
}

export function validateUserQueue(requestData) {
  return {
    [CALL_API]: {
      config: {
        data: requestData,
        method: 'post'
      },
      endpoint: apiEndpoints().entity(API.USER_VALIDATE_QUEUE),
      types: [
        AdminConstants.GET_VALIDATE_USER_QUEUES_DATA_REQUEST,
        AdminConstants.GET_VALIDATE_USER_QUEUES_DATA_SUCCESS,
        AdminConstants.GET_VALIDATE_USER_QUEUES_DATA_FAILED
      ]
    }
  };
}

export const changeRunQueryObject = (data, deleteIndex = null) => {
  return {
    type: AdminConstants.CHANGE_RUN_QUERY_OBJECT,
    data: data,
    deleteIndex: deleteIndex
  };
};

export const clearQueueCount = () => ({
  type: AdminConstants.CHANGE_RUN_QUERY_OBJECT_CLEAR
});
